import VuexTypes from '@/store/types/index';

const SyncAuditLogsTypes = VuexTypes.syncAuditLogs;
export default {
  [SyncAuditLogsTypes.SYNC_AUDIT_LOGS_LIST]: (state, { data, status }) => {
    state.syncAuditLogsList = { data, status };
  },
};
